import floral from "../../../pictures/home/floral.png";
import "../styles/page-hero.css";

/** Title band for inner pages: eyebrow, serif title, lead and an optional meta line. */
export function PageHero({ eyebrow, title, lead, meta, children }) {
  return (
    <section className="page-hero">
      <img className="page-hero-floral" src={floral} alt="" aria-hidden="true" />
      <div className="wrap page-hero-copy" data-reveal>
        {eyebrow && (
          <p className="eyebrow">
            <span /> {eyebrow} <span />
          </p>
        )}
        <h1>{title}</h1>
        {lead && <p className="page-hero-lead">{lead}</p>}
        {meta && <p className="page-hero-meta">{meta}</p>}
        {children}
      </div>
    </section>
  );
}
